import React from 'react';

import {
    FormControl,
    FormHelperText,
    ToggleButton,
    ToggleButtonGroup,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const ReactHookFormToggleButtonGroup = ({
    control,
    disabled,
    items,
    name,
    onChangedValue, // Nueva prop para manejar el cambio personalizado
    sx = {},
}) => (
    <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
            <FormControl error={Boolean(error)}>
                <ToggleButtonGroup
                    color="primary"
                    disabled={disabled}
                    exclusive
                    onChange={(e, newValue) => {
                        if (newValue !== null) {
                            onChange(parseInt(newValue)); // Actualiza el valor en el formulario
                            if (onChangedValue) onChangedValue(newValue); // Ejecuta la función personalizada
                        }
                    }}
                    size="small"
                    sx={sx}
                    value={value}
                >
                    {items.map((item, index) => (
                        <ToggleButton
                            disabled={disabled || item?.disabled}
                            key={`${name}-toggle-button-${index}`}
                            value={item.value}
                        >
                            {item.label}
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>

                {Boolean(error) && (
                    <FormHelperText>{error?.message}</FormHelperText>
                )}
            </FormControl>
        )}
    />
);

ReactHookFormToggleButtonGroup.propTypes = {
    control: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    items: PropTypes.array.isRequired,
    name: PropTypes.string.isRequired,
    onChangedValue: PropTypes.func, // Nueva prop opcional
    sx: PropTypes.object,
};

export default ReactHookFormToggleButtonGroup;
